import React, { useContext, useEffect } from 'react';
import { useState } from 'react';
import SSButton from '../SSButton';
import PCIcon from '../../assets/PC1.svg';
import PEIcon from '../../assets/pe02.svg';
import LEIcon from '../../assets/le02.svg';
import AEIcon from '../../assets/ae02.svg';
import StackBundle from '../../assets/sssb.png';
import './teamcontainer.scss';
import Avatar from 'react-avatar';
import PopUpContainer from '../PopUpContainer';
import InvitePopUp from '../InvitePopUp';
import { DOMAIN } from '../../Constants/base';
import { deleteReq, getReq, postReq } from '../../utils/api';
import { getSessionStorage, removeSessionStorage, returnLastActiveTime, shutdownIntercom } from '../../utils';
import EditMember from '../EditMember';
import { ActiveMember } from '../../context';
import { postLogger } from '../../utils/analytics';
import { trackEvents } from '../../utils/analytics';
import LoadingSpin from '../LoadingSpin';

export default function TeamContainer(props) {
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales')) || {};
  const [pageNo, setPageNo] = useState(1);

  const [, dispatchEditMember] = useContext(ActiveMember);
  const profiles = getSessionStorage('current-profile');

  const [pageMetadata, setPageMetadata] = useState({
    totalDocs: null,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    countLimit: 10,
    nextPage: 0,
  });
  const [members, setMembers] = useState([]);
  const [openInvitePopUp, setOpenInvitePopUp] = useState(false);
  const [editMemberPopUp, setEditMemberPopUp] = useState(false);
  const [availableTeamPlans, setAvailableTeamPlans] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  useEffect(() => {
    getTeamMembers();
    getTeamPlans();
  }, []);

  const getTeamPlans = async () => {
    let url = `${DOMAIN}/v1/stripe/user/plans?type=team`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    const agentsResponse = await getReq({
      url,
      requestHeaders,
    });
    const { code, data } = agentsResponse;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      setAvailableTeamPlans(data.plans);
    } else if (timeoutCode === '5') {
      let newPayload = {
        ...profiles,
        code,
      };
      postLogger('GET_TEAM_PLANS', newPayload);
    }
  };

  const getTeamMembers = async () => {
    setIsLoader(true);
    let url = `${DOMAIN}/v1/user/team-members/page/${pageNo}?pageLimit=${pageMetadata.countLimit}`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    const agentsResponse = await getReq({
      url,
      requestHeaders,
    });
    const { code, data } = agentsResponse;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      setIsLoader(false);
      if (data?.docs) {
        setMembers(data.docs);
        setPageNo(data.page);
        setPageMetadata({
          totalDocs: data.totalDocs,
          totalPages: data.totalPages,
          hasNextPage: data.hasNextPage,
          hasPreviousPage: data.hasPrevPage,
          countLimit: data.limit,
          nextPage: data.nextPage,
        });
      }
    } else if (timeoutCode === '5') {
      let newPayload = {
        ...profiles,
        code,
      };
      postLogger('GET_TEAM_MEMBERS', newPayload);
    }
  };

  const leaveTeamFunc = async () => {
    let url = `${DOMAIN}/v1/stripe/user/leave`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    const response = await deleteReq({ url, requestHeaders });
    const { code } = response;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      localStorage.removeItem('ss-auth-sales');
      localStorage.removeItem('ss-user-setup');
      removeSessionStorage('current-profile');
      shutdownIntercom();
      window.location = '/signin';
    } else if (timeoutCode === '5') {
      let newPayload = {
        ...profiles,
        code,
      };
      postLogger('LEAVE_TEAM', newPayload);
    }
  };
  const getTools = (tools) => {
    switch (tools) {
      case 'LEAD_ENGAGER':
        return (
          <div className="tool">
            <img src={LEIcon} alt="" />
          </div>
        );
        break;
      case 'PRO_CALLER':
        return (
          <div className="tool">
            <img src={PCIcon} alt="" />
          </div>
        );
      case 'AUDIENCE_ENGAGER':
        return (
          <div className="tool">
            <img src={AEIcon} alt="" />
          </div>
        );
      case 'PRO_EMAILER':
        return (
          <div className="tool">
            <img src={PEIcon} alt="" />
          </div>
        );
      default:
        return (
          <div className="tool">
            <img src={StackBundle} alt="" />
          </div>
        );
    }
  };
  return (
    <div>
      <div className="team-container">
        <div className="team-invite-container">
          <div className="member-count">
            <h1>
              {members.length} <span>Team Members</span>
            </h1>
            <p>
              {profiles?.roleType === 'OWNER' ? (
                <span>
                  Invite your team members and enable Sales Stack apps to share training data, settings, and context.
                  All under one subscription.
                </span>
              ) : (
                <span></span>
              )}
            </p>
          </div>
          {profiles.roleType === 'OWNER' ? (
            <SSButton
              btnText={'INVITE TEAM MEMBERS'}
              type={'filled'}
              onClickHandle={() => {
                setOpenInvitePopUp(true);
                // setCurrentStep(2);
                // setOpenTrainingPopUp(true);
              }}
            ></SSButton>
          ) : (
            <SSButton
              btnText={'LEAVE TEAM'}
              classBtn={'btn-danger'}
              onClickHandle={() => {
                leaveTeamFunc();
              }}
            ></SSButton>
          )}
        </div>
        {isLoader ? (
          <div className="team-container-loader">
            <LoadingSpin />
          </div>
        ) : (
          members.length > 0 && (
            <div className="team-members">
              <div
                className="header"
                style={{
                  gridTemplateColumns: profiles.roleType === 'OWNER' ? '5fr 4fr 4fr 2fr' : '5fr 4fr 4fr',
                }}
              >
                <div className="title">Team Member</div>
                <div className="title hide">Subscribed To</div>
                <div className="title end">Last Active</div>
                {profiles.roleType === 'OWNER' ? <div /> : <span></span>}
              </div>
              <div className="body">
                {members.map((member, idx) => {
                  return (
                    <div
                      className="member"
                      style={{
                        gridTemplateColumns: profiles.roleType === 'OWNER' ? '5fr 4fr 4fr 2fr' : '5fr 4fr 4fr',
                      }}
                      key={idx}
                    >
                      <div className="name">
                        <Avatar
                          name={member.name}
                          size="30px"
                          round={true}
                          color="white"
                          maxInitials={1}
                          textSizeRatio={2}
                          style={{ fontWeight: '400' }}
                        />
                        <span className="member-name">{member.name}</span>
                      </div>
                      <div className="subscription-tools">
                        {member.subscriptions.map((prod, idx) => {
                          return <div key={idx}>{getTools(prod?.product?.nickName, idx)}</div>;
                        })}
                      </div>

                      <div className="last-active">{returnLastActiveTime(member?.lastActiveInMillis)}</div>
                      {profiles.roleType === 'OWNER' && (
                        <SSButton
                          btnText={'Edit'}
                          onClickHandle={() => {
                            trackEvents('view_item_list', {
                              userId: profiles.userId,
                              item_list_name: 'edit_member',
                            });
                            dispatchEditMember({
                              type: 'CURRENT_EDIT_MEMBER',
                              payload: {
                                name: member.name,
                                email: member.email,
                                subscriptions: member.subscriptions,
                                id: member.id,
                                companyName: member.companyName,
                                role: member.role,
                                responseGenerated: member.responseGenerated,
                                assignedLeads: member.assignedLeads,
                              },
                            });
                            setEditMemberPopUp(true);
                          }}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )
        )}
      </div>
      {openInvitePopUp && (
        <PopUpContainer>
          <InvitePopUp
            setOpenInvitePopUp={setOpenInvitePopUp}
            availableTeamPlans={availableTeamPlans}
            getTeamMembers={getTeamMembers}
          />
        </PopUpContainer>
      )}
      {editMemberPopUp && (
        <PopUpContainer>
          <EditMember
            availableTeamPlans={availableTeamPlans}
            setEditMemberPopUp={setEditMemberPopUp}
            getTeamMembers={getTeamMembers}
          />
        </PopUpContainer>
      )}
    </div>
  );
}
